import React from "react";
import { useHistory } from "react-router-dom";

import GeneralEntBtnTypeNormalPlayerInfo from "components/player/structure/GeneralEntBtnTypeNormalPlayerInfo.class";

function ListItem({ info }) {
    const history = useHistory();

    const handleClickItem = () => {
        const playerInfo = new GeneralEntBtnTypeNormalPlayerInfo(info.PARAM);

        playerInfo.gotoPlayer(history);
    };

    return (
        <div className="recentlybox clear" onClick={handleClickItem}>
            <div className="recentlybox1 fl">
                <img src={info.IMG} />
            </div>
            <div className={"recentlybox2 fl linetwo"}>
                <span>{info.NAME} </span>
                {info.CNTT}
            </div>
        </div>
    );
}

export default ListItem;
